var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer-content"},[(_vm.before)?_c('i',{class:{ 'timer-circle': true, 'circle-show': _vm.isEven, 'circle-hide': !_vm.isEven }}):_vm._e(),_c('div',{staticClass:"timer-children"},[_vm._t("default")],2),(_vm.time)?_c('div',[_vm._v(" "+_vm._s(_vm.timer)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }